//  Images
export const summitLogo = 'summit-logo.png';
export const summitWhiteLogo = 'summit-white.svg';
export const blueHscLogo = '10125144bd977c159a89d0fc005e6f12ddfe5e211444d11fd7b0a0da802f16376afee7a4791d2bfde541e506c40dda657c8e36c97b7a0c2f1b7e63307a2a4ee1_blue-hsc-logo.png'
export const hscLogo = '6d823d0218585dbb63883414c840e9d84078390ccb7c34d5e586c7b3e96bb4a2f866d2e2a883b7b7e29ede656cea5f92511a09e5d598b12f2833451ac81f6095_hsc-logo.jpeg';
// Peak Capital logos (rebrand from High St Capital)
export const peakCapitalLogo = 'peak-capital-transparent.png'; // Dark text - for light backgrounds
export const peakCapitalLogoLight = 'peak-capital-dark.png'; // Light text - for dark backgrounds
export const videoImage = 'training/c311e4fc868d99a0f5309ae29b62226a0649502fcff35d1b6b120cfc62dc15de522e02467ab03e5cd71ef73defd0ac12b771356e6d50c189de99246cb8d559ca_video.png';

// Arc error codes & messages
export const existingFileError = 'E10P8A2'; // "Unable to update file, one with this path/name already exists. Please set overwrite flag or delete existing one first."
export const missingFileError = 'E10F7A1'; // "Failed to find file."
export const existingFileErrorMessage = "Unable to upload file, one with this path/name already exists"

// Text Editor
// export const editorApiKey = 'a96alr6pi7fram1jubqexsqi9rmkcn5zvcqnv3rj4i0y8c9z';
export const editorApiKey = 'v39bn3w1e8q6fcisl4oyaba0j6w57tsfeya5y3iv8ae4kvdd';

// Enums
export const fileTypes = {
    Document: 'file',
    Photo: 'photo'
};
export const GrossType = {
    Procured: 'procured',
    Paid: 'paid'
};
export const reportTypes = {
    MarketShare: 'market-share',
    MarketTransactionBreakdown: 'market-transaction-breakdown'
};

// Others
export const startYear = 2018;
export const startYearHscFees = 2019;

export const historyWeights = [
    {
        key: 'DATE',
        weight: 0,
    },
    {
        key: 'STATUS',
        weight: 1,
    },
    {
        key: 'LISTING_AGENT_1_FIRST_NAME',
        weight: 2,
    },
    {
        key: 'LISTING_AGENT_FIRM_NAME',
        weight: 3,
    },
    {
        key: 'PRICE',
        weight: 4,
    },
    {
        key: 'CAP_RATE',
        weight: 5,
    },
    {
        key: 'NET_OPERATING_INCOME',
        weight: 6,
    },
    {
        key: 'PRICE_PER_SQFT',
        weight: 7,
    },
    {
        key: 'BASE_RENT',
        weight: 8,
    },
    {
        key: 'RENT_PER_SQFT',
        weight: 9,
    },
    {
        key: 'VACANCY',
        weight: 10,
    },
    {
        key: 'BUYER_FIRST_NAME',
        weight: 11,
    },
    {
        key: 'SELLER_FIRST_NAME',
        weight: 12,
    },
];

export const pipelineRoutes = {
    active : 'active',
    inNegotiation : 'in-negotiation',
    underContract : 'under-contract',
    totalNegUc : 'total-neg-uc',
    inNegUcOther : 'other-neg-uc',
    closedYTD : 'closed-ytd',
    closedYTDOther : 'closed-ytd-other',
    totalClosedYTD : 'total-closed-ytd'
}

export const maxHscMembers = 2;
export const maxSummitMembers = 20;

/** How the investor and buyer pickers order a search: closest name, then A–Z, then newest. */
export const investorPickerSearchOrder = ['NAME_MATCH.asc', 'NAME.asc', 'ARCIMEDES_ROW_ID.desc'];
